

export enum AssigneeStrategy {
    STRATEGY_USER            = 'user',
    STRATEGY_ROUND_ROBIN     = 'round-robin',
    STRATEGY_RANDOM          = 'random',
    STRATEGY_BALANCED        = 'balanced-workload'
}

export const MULTI_USER_STRATEGIES = [AssigneeStrategy.STRATEGY_ROUND_ROBIN, AssigneeStrategy.STRATEGY_RANDOM, AssigneeStrategy.STRATEGY_BALANCED]

export const AssigneeStrategyOptions = [
    {value: AssigneeStrategy.STRATEGY_USER, label: 'Specific user'},
    {value: AssigneeStrategy.STRATEGY_ROUND_ROBIN, label: 'Round robin'},
    {value: AssigneeStrategy.STRATEGY_RANDOM, label: 'Random'},
    {value: AssigneeStrategy.STRATEGY_BALANCED, label: 'Balanced workload'},
]
